




















import CoSkeleton from '@/components/Atoms/co-skeleton/CoSkeleton.vue';
import CoHeadline from '@/components/Atoms/co-headline/CoHeadline.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoDate from '@/components/Molecules/co-date/CoDate.vue';
import CoEditorContent from '@/components/Molecules/co-editor-content/CoEditorContent.vue';

import axios from 'axios';

export default {
    name: 'LegalAgreements',
    components: {
        CoSkeleton,
        CoHeadline,
        CoText,
        CoDate,
        CoEditorContent,
    },
    props: {
        getUrl: {
            type: String,
        },
        title: {
            type: String,
        },
    },
    data() {
        return {
            content: null,
            loading: true,
            CreatedAt: null,
        };
    },
    computed: {
        // Use store-backed agreements when the public space endpoints are requested.
        usesStoreAgreement() {
            return this.getUrl === '/space/get-privacy-policy' || this.getUrl === '/space/get-terms-and-conditions';
        },
        storeAgreement() {
            if (this.getUrl === '/space/get-privacy-policy') {
                return this.$store.state.privacyPolicy;
            }
            if (this.getUrl === '/space/get-terms-and-conditions') {
                return this.$store.state.termsAndConditions;
            }
            return null;
        },
        storeAgreementLoaded() {
            if (this.getUrl === '/space/get-privacy-policy') {
                return this.$store.state.privacyPolicyLoaded;
            }
            if (this.getUrl === '/space/get-terms-and-conditions') {
                return this.$store.state.termsAndConditionsLoaded;
            }
            return false;
        },
    },
    watch: {
        // Keep the UI in sync when the store finishes loading agreements.
        storeAgreementLoaded() {
            this.syncStoreAgreement();
        },
    },
    mounted() {
        if (!this.getUrl) {
            console.warn('getUrl prop is required');
            return;
        }
        if (this.usesStoreAgreement) {
            this.syncStoreAgreement();
            return;
        }
        this.loading = true;
        axios({
            method: 'GET',
            url: this.getUrl,
            withCredentials: true,
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                this.content = response?.data?.Content;
                this.CreatedAt = response?.data?.CreatedAt;
            })
            .catch((error) => {
                console.log('error fetching legal agreement content', error);
            })
            .finally(() => {
                this.loading = false;
            });
    },
    methods: {
        // Pull agreement content from the store when available.
        syncStoreAgreement() {
            if (!this.usesStoreAgreement) {
                return;
            }
            this.content = this.storeAgreement?.Content || null;
            this.CreatedAt = this.storeAgreement?.CreatedAt || null;
            this.loading = !this.storeAgreementLoaded;
        },
    },
};
